<template>
    <div class="orderPayment mainContainer bgGray pbottom50">
        <div class="w11">
            <bread-crumb
                firstPath="/pcViews/learn"
                firstNav="在线学习"
                secondPath="/pcViews/learn/train"
                secondNav="教育培训"
            ></bread-crumb>
            <div class="orderType">订单支付</div>
            <!-- 订单基础信息开始 -->
            <order-base-info>
                <div class="order_info_title" slot="order_info_title">
                    <p>购买信息</p>
                </div>
                <el-table
                    :data="tableData"
                    :border="false"
                    slot="orderBaseInfoTable"
                >
                    <el-table-column prop="data" width="210" align="center">
                        <div class="orderCover">
                            <img
                                src="~assets/images/temporary/ordertit_Img.png"
                                alt=""
                                class="orderCover"
                            />
                        </div>
                    </el-table-column>
                    <el-table-column prop="name" label="商品">
                    </el-table-column>
                    <el-table-column align="center" label="商品有效期">
                        <template #default="scope">
                            <span class="colorOrange">{{
                                scope.row.startTime
                            }}</span>
                            <p>至</p>
                            <p>
                                {{ scope.row.endTime }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="num" label="商品数量" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="salePrice"
                        align="center"
                        label="价格"
                    >
                        <template #default="scope">
                            <span class="colorOrange"
                                >￥{{ scope.row.salePrice }}</span
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </order-base-info>
            <!-- 订单基础信息结束 -->
            <!-- 发票信息、支付方式开始 -->
            <div class="orderCorrelationInfo mtop30">
                <!-- 发票信息开始 -->
                <order-invoice>
                    <div class="order_info_title" slot="order_info_title">
                        <p>发票信息</p>
                        <span
                            >*开企业抬头发票须填写纳税人识别号，以免影响报销</span
                        >
                    </div>
                    <div class="orderInvoiceContent" slot="orderInvoiceContent">
                        <div>开具发票</div>
                        <div v-if="!changeInvoiceType">
                            <p v-if="invoiceInfo.titleType == '0'">个人</p>
                            <p v-else>单位</p>
                            <p>商品明细</p>
                        </div>
                        <div v-else>
                            <p>电子发票</p>
                            <em>-</em>
                            <p v-if="invoiceInfo.titleType == '0'">个人</p>
                            <p v-else>单位</p>
                        </div>
                        <div>
                            <span @click="showOrderInvoiceDialog">修改</span>
                        </div>
                    </div>
                </order-invoice>
                <invoice-info
                    :invoiceVisible="invoiceVisible"
                    :remoteInvoiceClose="remoteInvoiceClose"
                    :invoiceInfo="invoiceInfo"
                    @sendWriteInvoiceInfo="acceptWriteInvoiceInfo"
                ></invoice-info>
                <!-- 发票信息结束 -->
                <!-- 支付方式开始 -->
                <order-payment-method
                    :invoiceInfo="invoiceInfo"
                    :price="tableData[0].price.toString()"
                    :salePrice="tableData[0].salePrice.toString()"
                    :hasOrder="tableData[0].hasOrder"
                    :businessId="businessId"
                >
                    <div class="order_info_title" slot="order_info_title">
                        <p>支付方式</p>
                    </div>
                </order-payment-method>
                <!-- 支付方式结束 -->
            </div>
            <!-- 发票信息、支付方式结束  -->
        </div>
    </div>
</template>

<script>
import BreadCrumb from "components/contents/breadCrumb/BreadCrumb";
import OrderBaseInfo from "components/contents/orderBaseInfo/OrderBaseInfo";
import OrderInvoice from "components/contents/orderInvoice/OrderInvoice";
import OrderPaymentMethod from "components/contents/orderPaymentMethod/OrderPaymentMethod";

import InvoiceInfo from "components/common/invoiceInfo/InvoiceInfo";

import { PcCookie, Key } from "@/utils/cookie";

import { getCategoryPayInfo } from "api/train";

export default {
    components: {
        BreadCrumb,
        OrderBaseInfo,
        OrderInvoice,
        OrderPaymentMethod,
        InvoiceInfo,
    },
    data() {
        return {
            //发票填写模块开关
            invoiceVisible: false,
            //发票信息
            invoiceInfo: {
                titleName: "",
                phoneNumber: "",
                taxNumber: "",
                titleType: "",
            },
            //改变发票状态
            changeInvoiceType: false,
            tableData: [
                {
                    num: 1,
                    name: "",
                    price: 0,
                    salePrice: 0,
                    startTime: "",
                    endTime: "",
                    hasOrder: "0",
                },
            ],
            //培训报名id
            businessId:""
        };
    },
    created() {
        this.businessId = this.$route.query.trainId;
        this.feachTrainDetail();
    },
    methods: {
        //接受子组件 -- 填写、修改发票信息传过来的参数
        acceptWriteInvoiceInfo(data) {
            this.invoiceInfo.titleName =
                data.status === '0' ? data.userName : data.companyName;
            this.invoiceInfo.phoneNumber =
                data.status === '0' ? data.phone : data.companyPhone;
            this.invoiceInfo.taxNumber =
                data.status === '0' ? "" : data.invoiceNum;
            this.invoiceInfo.titleType = data.status;
            this.changeInvoiceType = true;
        },
        //显示填写、修改发票信息dialog
        showOrderInvoiceDialog() {
            this.invoiceVisible = true;
        },
        //关闭填写、修改发票信息dialog
        remoteInvoiceClose() {
            this.invoiceVisible = false;
        },
        //获取班级信息
        feachTrainDetail() {
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getCategoryPayInfo(sessionId,this.businessId).then((res) => {
                let { success, errorCode, body, msg } = res;
                if (success && errorCode == "2000") {
                    this.tableData[0].name = body.data.name;
                    this.tableData[0].price = body.data.price;
                    this.tableData[0].salePrice = body.data.salePrice;
                    this.tableData[0].startTime = body.data.startTime;
                    this.tableData[0].endTime = body.data.endTime;
                    this.tableData[0].hasOrder = body.data.hasOrder;
                    if(body.data.orderInfo){
                        this.invoiceInfo.phoneNumber = body.data.orderInfo.invoiceInfo.phoneNumber;
                        this.invoiceInfo.taxNumber = body.data.orderInfo.invoiceInfo.taxNumber;
                        this.invoiceInfo.titleName = body.data.orderInfo.invoiceInfo.titleName;
                        this.invoiceInfo.titleType = body.data.orderInfo.invoiceInfo.titleType;
                    }
                } else {
                    this.$message({
                        message: msg,
                        type: "error",
                    });
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.orderCorrelationInfo {
    padding: 42px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #ecedf1;
}
.orderType {
    font-size: 20px;
    font-weight: bold;
    color: #000;
    line-height: 56px;
    margin-bottom: 10px;
}
</style>
